import { NgTemplateOutlet } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import type { OnyxDateFormatOptions } from '@onyx/angular';
import { OnyxDateFormat, OnyxDatePipe } from '@onyx/angular';
import { ColorHelper } from '../../../helpers/color.helper';

@Component({
  selector: 'app-date-cell',
  imports: [OnyxDatePipe, TranslatePipe, NgTemplateOutlet],
  templateUrl: './date-cell.component.html',
  styleUrl: './date-cell.component.scss',
})
export class DateCellComponent {
  public readonly date = input.required<string | null>();
  public readonly format = input<OnyxDateFormat>(OnyxDateFormat.DATE_DOT);
  public readonly options = input<OnyxDateFormatOptions>();
  public readonly showWarnings = input(false);
  public readonly prefix = input<string | null>(null);

  protected cellColor = computed(() =>
    ColorHelper.getCellColor(this.date(), this.showWarnings()),
  );
}
